import { notification } from 'antd';
import { TextComponent } from 'baseComponents/TextComponent';
import { AdminPageWrapper } from 'components/layouts/AdminPageWrapper';
import { queryClient } from 'constants/query-client';
import { useNavigate } from 'react-router';
import { useAddTestUser } from 'hooks/useAddTestUser';
import { FullScreenLoaderComponent } from 'baseComponents/FullScreenLoaderComponent';
import { AdminTestUserPushForm } from 'components/AdminTestUserPushForm';

export const AdminAddTestUserPush = () => {
  const navigate = useNavigate();
  const [api, contextHolder] = notification.useNotification();

  const { mutate: addTestUser, isPending } = useAddTestUser({
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['test-users'],
      });
      navigate('/admin/manage/test-users-push', { state: 'success' });
    },
    onError: (e) => {
      return api.error({
        message: 'Something went wrong',
        description: e.response?.data.message || 'Failed to add test user',
        duration: 3,
      });
    },
  });

  return (
    <AdminPageWrapper sidebar={<div style={{ width: 160 }} />}>
      {contextHolder}
      <TextComponent size='table-title-size' text='Add test user push' />
      <AdminTestUserPushForm
        submitButtonLabel='Add'
        onCancel={() => navigate('/admin/manage/test-users-push')}
        onSubmit={(data) => {
          addTestUser({
            nickname: data.nickname,
            email: data.email,
            franchise_owner_id: data.franchiseOwner,
            channel: 'push',
          });
        }}
      />
      <FullScreenLoaderComponent spinning={isPending} />
    </AdminPageWrapper>
  );
};
